import { Component } from '@angular/core';
import { UiModule } from '@components/ui/ui-module';
import { environment } from '@environments/environment';

@Component({
  selector: 'op-home',
  imports: [
    UiModule
  ],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class Home {
  readonly url: string=`${environment.app_url}/install`;
}
